export default {
  PlacementsUpdater__BUTTON_GROUP_ARIA_NEXT: "Next",
  PlacementsUpdater__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
